module.exports = __webpack_public_path__ + "static/media/CTA 3.99015ab6.svg";